<template>
   <div id="page">
      <!-- Waitlist Form Component -->
      <WaitlistForm/>      
   </div>
</template>

<script>
import WaitlistForm from './WaitlistForm.vue';

export default {
   components: {
      WaitlistForm,
   },  
   data () {
      return {
         msg: ''
      }
   },
   methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#page {
   height: 100svh;
   margin: auto;
   background-image: url("../../assets/bloom-waitlist-bg-202405-light.png");
   background-size: cover;
   background-repeat: no-repeat;
   background-position: center center;
}

.content-row {
   margin: 2rem auto;
   max-width: 56rem;
   text-align: justify;
   height: 64svh;
}

.sub-list-1 {
   width: 80%;
   margin: auto;
}

.sub-list-1 li {
   margin: 0.7em 0em;
}

/* + Site Wide */
a, u {
    text-decoration: none;
}

a {
   color: #888888;
}
/* - Site Wide */

/* + Responsive UI */
@media screen and (max-width: 1040px) {
   #page { 
      width: auto;
   }

   .content-row {
      margin: 1rem 3rem;
   }
}

@media screen and (max-width: 740px) {
   #page { 
      width: auto;
      background: none;
   }

   .content-row {
      margin: 1rem 1rem;
   }   
}

@media screen and (max-width: 480px) {
   #page { 
      width: auto;
   }
}
/* - Responsive UI */

</style>



// WEBPACK FOOTER //
// src/components/site/BloomWaitlist.vue